<div class="hero-media" aria-hidden="true">
    <img ngSrc="/images/about/veyora-about-hero.webp" fill priority
        alt="Veyora Fit activewear in a calm movement studio">
</div>
<div class="hero-wash" aria-hidden="true"></div>

<div class="hero-content">
    <div class="brand-mark" showleft [showDelay]="0">
        <app-logo [size]="46"></app-logo>
        <span>{{appname}}</span>
    </div>
    <p class="eyebrow" showleft [showDelay]="70">Movement, softened</p>
    <h1 showleft [showDelay]="140">Soft power for the way your day actually moves.</h1>
    <p class="summary" showleft [showDelay]="210">We make activewear feel composed: smooth support, breathable
        stretch, and refined silhouettes that move from studio time into everything after.</p>
    <div class="signals" showleft [showDelay]="280">
        <span>Quiet confidence</span>
        <span>Studio-to-day comfort</span>
        <span>Details that stay put</span>
    </div>
</div>

<div class="hero-card" showin [showDelay]="360" aria-label="Veyora Fit design note">
    <span>Designed around real movement</span>
    <strong>soft hold / clean lines / all-day ease</strong>
</div>
